export const elementsCache = /*#__PURE__*/new WeakMap();